/**
 * スムーススクロール
 * @param {string} hash
 */
export const smoothScroll = hash => {
  const $target = document.querySelector(hash || 'html');
  const $header = document.getElementById('header');

  const y = $target.getBoundingClientRect().top;
  const top = window.scrollY + y - $header.clientHeight;
  const option = { behavior: 'smooth', top: top };

  window.scrollTo(option);
};
